module.exports = __webpack_public_path__ + "img/func1.f1a40624.png";